"use client";

import { c as _c } from "react/compiler-runtime";
import type { ApiWave } from "@/generated/models/ApiWave";
import { MyStreamWaveTab } from "@/types/waves.types";
import { faArrowRight, faBook, faChartLine, faCrown, faCubes, faTools, faUser, faVoteYea } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Link from "next/link";
import React, { useEffect } from "react";
import { useContentTab } from "../ContentTabContext";
import { useLayout } from "./layout/LayoutContext";
interface MyStreamWaveFAQProps {
  readonly wave: ApiWave;
}
const MyStreamWaveFAQ: React.FC<MyStreamWaveFAQProps> = t0 => {
  const $ = _c(64);
  const {
    setActiveContentTab
  } = useContentTab();
  const {
    faqViewStyle
  } = useLayout();
  let t1;
  let t2;
  if ($[0] !== setActiveContentTab) {
    t1 = () => {
      setActiveContentTab(MyStreamWaveTab.FAQ);
    };
    t2 = [setActiveContentTab];
    $[0] = setActiveContentTab;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <p className="tw-text-iron-50 tw-font-semibold tw-text-xl sm:tw-text-2xl tw-mb-0">The Memes - Main Stage FAQ</p>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <h3 className="tw-mt-6 sm:tw-mt-8 tw-text-lg sm:tw-text-xl tw-font-semibold tw-text-iron-50 tw-mb-5 tw-flex tw-items-center"><div className="tw-flex tw-items-center tw-justify-center tw-bg-iron-800 tw-rounded-md tw-w-8 tw-h-8 tw-mr-3"><FontAwesomeIcon icon={faBook} className="tw-text-primary-400 tw-size-4 tw-flex-shrink-0" /></div>Intro</h3>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="tw-border-b tw-border-iron-800"><div className="tw-text-sm tw-text-iron-400 tw-font-medium">What are we doing here?</div><div className="tw-text-iron-50 tw-mt-1 tw-text-base">Voting for the next The Memes card to be minted</div></div>;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <div className="tw-border-b tw-border-iron-800"><div className="tw-text-sm tw-text-iron-400 tw-font-medium">Who is voting?</div><div className="tw-text-iron-50 tw-mt-1 tw-text-base">Everyone with TDH</div></div>;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <div className="tw-border-b tw-border-iron-800"><div className="tw-text-sm tw-text-iron-400 tw-font-medium">What are we voting with?</div><div className="tw-text-iron-50 tw-mt-1 tw-text-base">TDH</div></div>;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <section className="tw-bg-iron-900 tw-rounded-lg tw-px-4 tw-py-5 sm:tw-p-6 tw-border tw-border-iron-800 tw-border-solid tw-shadow-sm">{t3}{t4}<div className="tw-flex tw-flex-col tw-space-y-4 md:tw-space-y-6 tw-mb-0">{t5}{t6}{t7}<div className="tw-border-b tw-border-iron-800"><div className="tw-text-sm tw-text-iron-400 tw-font-medium">How do I learn more?</div><div className="tw-text-iron-50 tw-mt-1 tw-text-base">Keep reading</div></div></div></section>;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t10;
  let t11;
  let t12;
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <h3 className="tw-text-lg sm:tw-text-xl tw-font-semibold tw-text-iron-50 tw-mb-5 tw-flex"><div className="tw-flex tw-items-center tw-justify-center tw-bg-iron-800 tw-rounded-md tw-w-8 tw-h-8 tw-mr-3"><FontAwesomeIcon icon={faCrown} className="tw-text-indigo-500 tw-size-4 tw-flex-shrink-0" /></div><div className="tw-mt-0.5">What are the goals of the voting?</div></h3>;
    t10 = <p className="tw-text-iron-300 tw-mb-4 tw-leading-relaxed tw-text-base">We are engaging in decentralized, networked curation of an important NFT art collection focused on decentralization.</p>;
    t11 = <p className="tw-text-iron-300 tw-mb-4 tw-leading-relaxed tw-text-base">The goal is excellence, defined as a collection that will age well over decades.</p>;
    t12 = <p className="tw-text-iron-300 tw-mb-3 tw-leading-relaxed tw-text-base">Excellence can come in many formats:</p>;
    $[9] = t10;
    $[10] = t11;
    $[11] = t12;
    $[12] = t9;
  } else {
    t10 = $[9];
    t11 = $[10];
    t12 = $[11];
    t9 = $[12];
  }
  let t13;
  let t14;
  let t15;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <ul className="tw-space-y-2 tw-text-iron-300 tw-mb-5 tw-pl-1 tw-text-base">{["Artistic excellence", "Memetic excellence", "Story-value excellence", "Several of the above"].map(_temp)}</ul>;
    t14 = <p className="tw-text-iron-300 tw-mb-4 tw-leading-relaxed tw-text-base">There is a long artist brief here that both artists and first-time voters should read.</p>;
    t15 = <p className="tw-text-iron-300 tw-mb-5 tw-leading-relaxed tw-text-base">It is a much more detailed FAQ than this one and if you want to be seriously engaged with this effort, you must read it! Otherwise you will bother everyone with basic questions that you could have answered by reading the presentation and we will quietly think a little less of you and nobody wants that.</p>;
    $[13] = t13;
    $[14] = t14;
    $[15] = t15;
  } else {
    t13 = $[13];
    t14 = $[14];
    t15 = $[15];
  }
  let t16;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <section className="tw-bg-iron-900 tw-rounded-lg tw-px-4 tw-py-5 sm:tw-p-6 tw-border tw-border-iron-800 tw-border-solid tw-shadow-sm">{t9}{t10}{t11}{t12}{t13}{t14}{t15}<a href="https://docs.google.com/presentation/d/1Aejko31qFkAIyu-Qc3Ao9tHQGbbaFCIcqrBj_kZzo_M/edit#slide=id.p1" target="_blank" rel="noopener noreferrer" className="tw-group tw-text-base tw-flex tw-items-center tw-text-primary-400 tw-font-medium desktop-hover:hover:tw-text-primary-300 tw-transition-colors">Read Artist Brief<FontAwesomeIcon icon={faArrowRight} className="tw-ml-2 tw-size-3 tw-transition-transform desktop-hover:group-hover:tw-translate-x-0.5" /></a><p className="tw-text-iron-500 tw-mt-4 tw-text-sm">These FAQs are a summary of this presentation but not a substitute for reading it.</p></section>;
    $[16] = t16;
  } else {
    t16 = $[16];
  }
  let t17;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <h3 className="tw-text-lg sm:tw-text-xl tw-font-semibold tw-text-iron-50 tw-mb-5 tw-flex"><div className="tw-flex tw-items-center tw-justify-center tw-bg-iron-800 tw-rounded-md tw-w-8 tw-h-8 tw-mr-3"><FontAwesomeIcon icon={faUser} className="tw-text-red tw-size-4 tw-flex-shrink-0" /></div><span className="tw-mt-0.5">What Are Not The Goals Of The Voting</span></h3>;
    $[17] = t17;
  } else {
    t17 = $[17];
  }
  let t18;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t18 = <li className="tw-flex tw-items-start tw-pb-3 tw-text-base"><span className="tw-text-red tw-mr-2">✕</span><span>We should not vandalize the collection for joke value.</span></li>;
    $[18] = t18;
  } else {
    t18 = $[18];
  }
  let t19;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <li className="tw-flex tw-items-start tw-pb-3 tw-text-base"><span className="tw-text-red tw-mr-2">✕</span><span>The Memes are not a sandbox for goofing around among friends – they are, arguably, the most important large NFT art collection of 2022-2025.</span></li>;
    $[19] = t19;
  } else {
    t19 = $[19];
  }
  let t20;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = <span className="tw-text-emerald-500 tw-mr-2">✓</span>;
    $[20] = t20;
  } else {
    t20 = $[20];
  }
  let t21;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t21 = <li className="tw-flex tw-items-start tw-pb-3 tw-text-base">{t20}<span>Our decisions should stand the test of time – "{" "}<span className="tw-italic">can you imagine someone wanting to own the card 30 years from now?</span>{" "}" is a pretty good test.</span></li>;
    $[21] = t21;
  } else {
    t21 = $[21];
  }
  let t22;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <li className="tw-flex tw-items-start  tw-pb-3 tw-text-base"><span className="tw-text-emerald-500 tw-mr-2">✓</span><span>Should we do weird things in The Memes? Sure, so long as they are also excellent.</span></li>;
    $[22] = t22;
  } else {
    t22 = $[22];
  }
  let t23;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <section className="tw-bg-iron-900 tw-rounded-lg tw-px-4 tw-py-5 sm:tw-p-6 tw-border tw-border-iron-800 tw-border-solid tw-shadow-sm">{t17}<ul className="tw-space-y-3 tw-text-iron-300 tw-pl-0">{t18}{t19}{t21}{t22}<li className="tw-flex tw-items-start tw-text-base"><span className="tw-text-red tw-mr-2">✕</span><span>Should we do weird casual things that are not excellent? No.</span></li></ul></section>;
    $[23] = t23;
  } else {
    t23 = $[23];
  }
  let t24;
  let t25;
  let t26;
  let t27;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <h3 className="tw-text-lg sm:tw-text-xl tw-font-semibold tw-text-iron-50 tw-mb-5 tw-flex"><div className="tw-flex tw-items-center tw-justify-center tw-bg-iron-800 tw-rounded-md tw-w-8 tw-h-8 tw-mr-3"><FontAwesomeIcon icon={faVoteYea} className="tw-text-purple-500 tw-size-4 tw-flex-shrink-0" /></div><span className="tw-mt-0.5">How Does Voting Work?</span></h3>;
    t25 = <p className="tw-text-iron-300 tw-mb-4 tw-leading-relaxed tw-text-base">Voting is a continuous leaderboard – art is submitted and it stays on the leaderboard until it is removed by the artist who submitted it.</p>;
    t26 = <p className="tw-text-iron-300 tw-mb-4 tw-leading-relaxed tw-text-base">Three times a week, the top submission on the leaderboard is selected to be the next card minted.</p>;
    t27 = <p className="tw-text-iron-300 tw-mb-4 tw-leading-relaxed tw-text-base">The checkpoint times are Monday / Wednesday / Friday at 17:00 GMT. The card will be minted at the next The Memes mint (e.g. Wednesday / Friday / Monday).</p>;
    $[24] = t24;
    $[25] = t25;
    $[26] = t26;
    $[27] = t27;
  } else {
    t24 = $[24];
    t25 = $[25];
    t26 = $[26];
    t27 = $[27];
  }
  let t28;
  let t29;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <p className="tw-text-iron-300 tw-mb-4 tw-leading-relaxed tw-text-base">The metric that determines the winner is 24-Hour Vote (24HV).<br />24HV is a weighted average of how much TDH was voted at any point in time ("Current Vote") during the last 24 hours before the checkpoint.</p>;
    t29 = <p className="tw-text-iron-300 tw-mb-5 tw-leading-relaxed tw-text-base">The purpose of using 24HV is to avoid last second gaming of the vote. You can sort by 24HV and Current Vote. 24HV converges to Current Vote over a 24 hour period (noting that Current Vote is constantly changing).</p>;
    $[28] = t28;
    $[29] = t29;
  } else {
    t28 = $[28];
    t29 = $[29];
  }
  let t30;
  if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
    t30 = <p className="tw-text-iron-50 tw-font-medium tw-mb-4 tw-text-base">You can think of the voting in three phases:</p>;
    $[30] = t30;
  } else {
    t30 = $[30];
  }
  let t31;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t31 = <div className="tw-bg-iron-900 tw-p-4 tw-rounded-md tw-border-l-4 tw-border-primary-500 tw-border-solid tw-border-r-0 tw-border-y-0"><p className="tw-font-semibold tw-text-iron-50 tw-text-base">Pre-voting</p><p className="tw-text-sm tw-text-iron-400 tw-mt-1">{">24h before"}</p><p className="tw-text-iron-300 tw-mt-2">You can add and remove TDH (Current Vote) to one or more submissions but it does not impact the final decision.</p></div>;
    $[31] = t31;
  } else {
    t31 = $[31];
  }
  let t32;
  if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
    t32 = <div className="tw-bg-iron-900 tw-p-4 tw-rounded-md tw-border-l-4 tw-border-purple-600 tw-border-solid tw-border-r-0 tw-border-y-0"><p className="tw-font-semibold tw-text-iron-50 tw-text-base">Voting</p><p className="tw-text-sm tw-text-iron-400 tw-mt-1">0-24h before</p><p className="tw-text-iron-300 tw-mt-2">You can add and remove TDH (Current Vote) to one more submissions, but it does impact the final decision as it starts counting towards the final 24HV. If you vote 100 TDH for the whole 24-hour period, it contributes 100 to the final vote. If you vote 100 TDH for 12 hours of the last 24 hours, it contributes 50 to the final vote.</p></div>;
    $[32] = t32;
  } else {
    t32 = $[32];
  }
  let t33;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <div className="tw-bg-iron-950 tw-p-4 sm:tw-p-5 tw-rounded-md tw-mb-6">{t30}<div className="tw-grid tw-grid-cols-1 tw-gap-4">{t31}{t32}<div className="tw-bg-iron-900 tw-p-4 tw-rounded-md tw-border-l-4 tw-border-emerald-500 tw-border-solid tw-border-r-0 tw-border-y-0"><p className="tw-font-semibold tw-text-iron-50 tw-text-base">Selection</p><p className="tw-text-sm tw-text-iron-400 tw-mt-1">Checkpoint</p><p className="tw-text-iron-300 tw-mt-2">The 24HV value at checkpoint time</p></div></div></div>;
    $[33] = t33;
  } else {
    t33 = $[33];
  }
  let t34;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t34 = <section className="tw-bg-iron-900 tw-rounded-lg tw-px-4 tw-py-5 sm:tw-p-6 tw-border tw-border-iron-800 tw-border-solid tw-shadow-sm">{t24}{t25}{t26}{t27}{t28}{t29}{t33}<div className="tw-flex tw-flex-col tw-space-y-3">{[{
          q: "Can you add and remove TDH at any time?",
          a: "Yes"
        }, {
          q: "Can you give TDH to more than one card?",
          a: "Yes"
        }, {
          q: "How much of your TDH can you use?",
          a: "All of it - the aggregate of your positive and negative votes can add up to your total TDH"
        }, {
          q: "Does your TDH get destroyed by voting?",
          a: "No"
        }, {
          q: "What happens when a card I voted for gets selected?",
          a: "You get your TDH back"
        }, {
          q: "What happens when I get TDH back from removing it from a card I voted for?",
          a: "You get Current Vote TDH instantly but 24HV TDH decays and accrues over 24 hours"
        }].map(_temp2)}</div></section>;
    $[34] = t34;
  } else {
    t34 = $[34];
  }
  let t35;
  if ($[35] === Symbol.for("react.memo_cache_sentinel")) {
    t35 = <h3 className="tw-text-lg sm:tw-text-xl tw-font-semibold tw-text-iron-50 tw-mb-5 tw-flex"><div className="tw-flex tw-items-center tw-justify-center tw-bg-iron-800 tw-rounded-md tw-w-8 tw-h-8 tw-mr-3"><FontAwesomeIcon icon={faTools} className="tw-text-emerald-500-500 tw-size-4" /></div><span className="tw-mt-0.5">How Does Submission Work?</span></h3>;
    $[35] = t35;
  } else {
    t35 = $[35];
  }
  let t36;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t36 = <p className="tw-text-iron-50 tw-font-medium tw-mb-3 tw-text-base">There are two ways you can be eligible to submit:</p>;
    $[36] = t36;
  } else {
    t36 = $[36];
  }
  let t37;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t37 = <li className="tw-flex tw-text-base"><span className="tw-text-emerald-500 tw-size-4 tw-flex-shrink-0 tw-mr-2">✓</span>You have previously dropped a Meme Card</li>;
    $[37] = t37;
  } else {
    t37 = $[37];
  }
  let t38;
  let t39;
  let t40;
  if ($[38] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = <div className="tw-bg-iron-950 tw-p-5 tw-rounded-md tw-mb-5">{t36}<ul className="tw-space-y-3 tw-text-iron-300 tw-pl-0">{t37}<li className="tw-flex tw-text-base"><span className="tw-text-emerald-500 tw-size-4 tw-flex-shrink-0 tw-mr-2">✓</span>You have been nominated in a decentralized way by one or more people giving you at least 50,000 "MemesNominee" rep</li></ul></div>;
    t39 = <p className="tw-text-iron-300 tw-mb-2 tw-leading-relaxed tw-text-base">What if I do not know how to get nominated?</p>;
    t40 = <p className="tw-text-iron-300 tw-mb-3 tw-leading-relaxed tw-text-base">Go to the The Memes - Seeking Nomination wave and share your existing work and story and someone may nominate you:</p>;
    $[38] = t38;
    $[39] = t39;
    $[40] = t40;
  } else {
    t38 = $[38];
    t39 = $[39];
    t40 = $[40];
  }
  let t41;
  let t42;
  let t43;
  if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
    t41 = <Link href="https://6529.io/waves?wave=0ecb95d0-d8f2-48e8-8137-bfa71ee8593c" target="_blank" rel="noopener noreferrer" className="tw-group tw-flex tw-text-base tw-items-center tw-text-primary-400 tw-font-medium desktop-hover:hover:tw-text-primary-300 tw-transition-colors tw-mb-4">Nomination Wave<FontAwesomeIcon icon={faArrowRight} className="tw-ml-2 tw-size-3 tw-transition-transform desktop-hover:group-hover:tw-translate-x-0.5" /></Link>;
    t42 = <p className="tw-text-iron-300 tw-mb-4 tw-leading-relaxed tw-text-base">Once you are eligible, you can submit up to 3 cards at a time. If you remove a submission or one of your submissions is selected to be minted, you can submit another card to fill that spot.</p>;
    t43 = <p className="tw-text-iron-300 tw-mb-3 tw-leading-relaxed tw-text-base">It is very important to read the artist brief so that you don't waste your time:</p>;
    $[41] = t41;
    $[42] = t42;
    $[43] = t43;
  } else {
    t41 = $[41];
    t42 = $[42];
    t43 = $[43];
  }
  let t44;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t44 = <li className="tw-flex"><div className="tw-h-0.5 tw-w-3 tw-mt-2.5 tw-rounded-full tw-flex-shrink-0 tw-bg-primary-400 tw-mr-3" />High quality submissions, in line with the collection mission, will do very well</li>;
    $[44] = t44;
  } else {
    t44 = $[44];
  }
  let t45;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t45 = <ul className="tw-space-y-2 tw-text-iron-300 tw-mb-5 tw-pl-1 tw-text-base">{t44}<li className="tw-flex"><div className="tw-h-0.5 tw-w-3 tw-mt-2.5 tw-rounded-full tw-flex-shrink-0 tw-bg-primary-400 tw-mr-3" />Low effort submissions will not get selected</li></ul>;
    $[45] = t45;
  } else {
    t45 = $[45];
  }
  let t46;
  let t47;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t46 = <div className="tw-bg-iron-950 tw-p-5 tw-rounded-md tw-border tw-border-iron-800 tw-mb-5"><p className="tw-text-iron-300 tw-mb-2 tw-leading-relaxed tw-text-base">How do I get some artistic feedback as in the past?</p><p className="tw-text-iron-50 tw-text-base">DM @6529er, @teexels and @darrensrs into a group chat</p></div>;
    t47 = <p className="tw-text-iron-300 tw-mb-3 tw-leading-relaxed tw-text-base">What if I have general questions? Go to the The Memes - FAQ wave (after you have read the artist brief)</p>;
    $[46] = t46;
    $[47] = t47;
  } else {
    t46 = $[46];
    t47 = $[47];
  }
  let t48;
  if ($[48] === Symbol.for("react.memo_cache_sentinel")) {
    t48 = <section className="tw-bg-iron-900 tw-rounded-lg tw-px-4 tw-py-5 sm:tw-p-6 tw-border tw-border-iron-800 tw-border-solid tw-shadow-sm">{t35}{t38}{t39}{t40}{t41}{t42}{t43}{t45}{t46}{t47}<Link href="https://6529.io/waves?wave=e2dae377-d27d-4a69-8b77-38d88fad4d01" target="_blank" rel="noopener noreferrer" className="tw-group tw-flex tw-items-center tw-text-primary-400 tw-font-medium desktop-hover:hover:tw-text-primary-300 tw-transition-colors">FAQ Wave<FontAwesomeIcon icon={faArrowRight} className="tw-ml-2 tw-text-base tw-size-3 tw-flex-shrink-0 tw-transition-transform desktop-hover:group-hover:tw-translate-x-0.5" /></Link></section>;
    $[48] = t48;
  } else {
    t48 = $[48];
  }
  let t49;
  let t50;
  let t51;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t49 = <h3 className="tw-text-lg sm:tw-text-xl tw-font-semibold tw-text-iron-50 tw-mb-5 tw-flex tw-items-center"><div className="tw-flex tw-items-center tw-justify-center tw-bg-iron-800 tw-rounded-md tw-w-8 tw-h-8 tw-mr-3"><FontAwesomeIcon icon={faChartLine} className="tw-text-[#FEDF89] tw-size-4 tw-flex-shrink-0" /></div>What is TDH?</h3>;
    t50 = <p className="tw-text-iron-300 tw-mb-4 tw-leading-relaxed tw-text-base">TDH is the central metric of 6529 ecosystem.</p>;
    t51 = <p className="tw-text-iron-300 tw-mb-5 tw-leading-relaxed tw-text-base">It is a quantitative metric reflecting how long you have held a 6529 NFT, how many you have held and how diverse your holdings are. It primarily rewards longevity.</p>;
    $[49] = t49;
    $[50] = t50;
    $[51] = t51;
  } else {
    t49 = $[49];
    t50 = $[50];
    t51 = $[51];
  }
  let t52;
  if ($[52] === Symbol.for("react.memo_cache_sentinel")) {
    t52 = <Link href="https://x.com/punk6529/status/1906753171751412006" target="_blank" rel="noopener noreferrer" className="tw-group tw-text-base tw-flex tw-items-center tw-text-primary-400 tw-font-medium desktop-hover:hover:tw-text-primary-300 tw-transition-colors">Theory<FontAwesomeIcon icon={faArrowRight} className="tw-ml-2 tw-size-3 tw-transition-transform desktop-hover:group-hover:tw-translate-x-0.5" /></Link>;
    $[52] = t52;
  } else {
    t52 = $[52];
  }
  let t53;
  if ($[53] === Symbol.for("react.memo_cache_sentinel")) {
    t53 = <section className="tw-bg-iron-900 tw-rounded-lg tw-px-4 tw-py-5 sm:tw-p-6 tw-border tw-border-iron-800 tw-border-solid tw-shadow-sm">{t49}{t50}{t51}<div className="tw-flex tw-gap-4">{t52}<Link href="https://6529.io/network/tdh" target="_blank" rel="noopener noreferrer" className="tw-group tw-text-base tw-flex tw-items-center tw-text-primary-400 tw-font-medium desktop-hover:hover:tw-text-primary-300 tw-transition-colors">Formula<FontAwesomeIcon icon={faArrowRight} className="tw-ml-2 tw-size-3 tw-transition-transform desktop-hover:group-hover:tw-translate-x-0.5" /></Link></div></section>;
    $[53] = t53;
  } else {
    t53 = $[53];
  }
  let t54;
  let t55;
  if ($[54] === Symbol.for("react.memo_cache_sentinel")) {
    t54 = <h3 className="tw-text-lg sm:tw-text-xl tw-font-semibold tw-text-iron-50 tw-mb-5 tw-flex tw-items-center"><div className="tw-flex tw-items-center tw-justify-center tw-bg-iron-800 tw-rounded-md tw-w-8 tw-h-8 tw-mr-3"><FontAwesomeIcon icon={faCubes} className="tw-text-orange-500 tw-size-4 tw-flex-shrink-0" /></div>Minting a Meme Card</h3>;
    t55 = <p className="tw-text-iron-300 tw-mb-4 tw-leading-relaxed tw-text-base">Everything about minting a Meme Card stays unchanged.</p>;
    $[54] = t54;
    $[55] = t55;
  } else {
    t54 = $[54];
    t55 = $[55];
  }
  let t56;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t56 = <div className="tw-bg-iron-950 tw-p-4 tw-rounded-md"><p className="tw-text-iron-400 tw-text-sm tw-uppercase tw-tracking-wider tw-mb-1">Mint price</p><p className="tw-text-iron-50 tw-text-base">0.06529 ETH</p></div>;
    $[56] = t56;
  } else {
    t56 = $[56];
  }
  let t57;
  let t58;
  let t59;
  if ($[57] === Symbol.for("react.memo_cache_sentinel")) {
    t57 = <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 tw-gap-4 tw-mb-5">{t56}<div className="tw-bg-iron-950 tw-p-4 tw-rounded-md"><p className="tw-text-iron-400 tw-text-sm tw-uppercase tw-tracking-wider tw-mb-1">Edition sizes</p><p className="tw-text-iron-50 tw-text-base">In the 300s right now</p></div></div>;
    t58 = <p className="tw-text-iron-300 tw-mb-4 tw-leading-relaxed tw-text-base">You can mint based on the Allowlist Phase you are in based on your TDH (P0, P1, P2) or public (if it goes to public).</p>;
    t59 = <p className="tw-text-iron-300 tw-mb-4 tw-leading-relaxed tw-text-base">You can get priority within your Phase by subscribing in advance from your profile page. Details are here:</p>;
    $[57] = t57;
    $[58] = t58;
    $[59] = t59;
  } else {
    t57 = $[57];
    t58 = $[58];
    t59 = $[59];
  }
  let t60;
  if ($[60] === Symbol.for("react.memo_cache_sentinel")) {
    t60 = <section className="tw-bg-iron-900 tw-rounded-lg tw-px-4 tw-py-5 sm:tw-p-6 tw-border tw-border-iron-800 tw-border-solid tw-shadow-sm">{t54}{t55}{t57}{t58}{t59}<Link href="https://6529.io/about/subscriptions" target="_blank" rel="noopener noreferrer" className="tw-group tw-flex tw-items-center tw-text-primary-400 tw-font-medium desktop-hover:hover:tw-text-primary-300 tw-transition-colors">Subscriptions<FontAwesomeIcon icon={faArrowRight} className="tw-ml-2 tw-text-base tw-size-3 tw-transition-transform desktop-hover:group-hover:tw-translate-x-0.5" /></Link></section>;
    $[60] = t60;
  } else {
    t60 = $[60];
  }
  let t61;
  if ($[61] === Symbol.for("react.memo_cache_sentinel")) {
    t61 = <div className="tw-space-y-4 md:tw-space-y-6 tw-mb-4 tw-px-2 sm:tw-px-4">{t8}{t16}{t23}{t34}{t48}{t53}{t60}<div className="tw-text-center tw-p-5 tw-rounded-lg"><p className="tw-text-iron-200 tw-text-base tw-font-medium tw-mb-0">Welcome aboard!</p></div></div>;
    $[61] = t61;
  } else {
    t61 = $[61];
  }
  let t62;
  if ($[62] !== faqViewStyle) {
    t62 = <div className="tw-w-full tw-flex tw-flex-col tw-pt-4 lg:tw-pr-2 tw-overflow-y-auto no-scrollbar lg:tw-scrollbar-thin tw-scrollbar-thumb-iron-500 tw-scrollbar-track-iron-800 desktop-desktop-hover:hover:desktop-hover:hover:tw-scrollbar-thumb-iron-300 tw-h-full" style={faqViewStyle}>{t61}</div>;
    $[62] = faqViewStyle;
    $[63] = t62;
  } else {
    t62 = $[63];
  }
  return t62;
};
export default MyStreamWaveFAQ;
function _temp(item, idx) {
  return <li key={idx} className="tw-flex tw-items-center"><div className="tw-h-0.5 tw-w-3 tw-flex-shrink-0 tw-rounded-full tw-bg-primary-400 tw-mr-3" />{item}</li>;
}
function _temp2(item_0, idx_0) {
  return <div key={idx_0} className="tw-border-b tw-border-iron-800 tw-pb-3  "><dt className="tw-text-sm tw-font-medium tw-text-primary-400">{item_0.q}</dt><dd className="tw-text-iron-50 tw-mt-1 tw-text-base">{item_0.a}</dd></div>;
}